import { ref } from 'vue'
import { postFlyToPoint, PostFlyToPointBody, deleteFlyToPoint, postTakeoffToPoint, PostTakeoffToPointBody, postTakeoffToPointRc } from '/@/api/drone-control/drone'
import { message } from 'ant-design-vue'

export function useDroneControl () {
  const droneControlPanelVisible = ref(false)

  function setDroneControlPanelVisible (visible: boolean) {
    droneControlPanelVisible.value = visible
  }

  async function flyToPoint (sn: string, body: PostFlyToPointBody) {
    const { code } = await postFlyToPoint(sn, body)
    if (code === 0) {
      message.success('正在飞往目标点.')
    }
  }

  async function stopFlyToPoint (sn: string) {
    const { code } = await deleteFlyToPoint(sn)
    if (code === 0) {
      message.success('停止飞往目标点.')
    }
  }

  async function takeoffToPoint (sn: string, body: PostTakeoffToPointBody) {
    const { code } = await postTakeoffToPoint(sn, body)
    if (code === 0) {
      message.success('成功起飞.')
    }
    return code
  }
  async function takeoffToPointRc (sn: string, body: PostTakeoffToPointBody) {
    const { code } = await postTakeoffToPointRc(sn, body)
    if (code === 0) {
      message.success('成功起飞.')
    }
    return code
  }

  return {
    droneControlPanelVisible,
    setDroneControlPanelVisible,
    flyToPoint,
    stopFlyToPoint,
    takeoffToPoint,
    takeoffToPointRc
  }
}
